const C = {
  name: "Coins",
  dimensions: { width: 20, height: 20 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.33458 4.00687C9.15615 1.67341 11.383 0 14 0C17.3123 0 20 2.68772 20 6C20 8.62079 18.3283 10.8396 15.993 11.6624C15.9977 11.7744 16 11.8869 16 12C16 16.4183 12.4183 20 8 20C3.58172 20 0 16.4183 0 12C0 7.58172 3.58172 4 8 4C8.11208 4 8.22362 4.00231 8.33458 4.00687ZM10.3498 4.35067C10.9778 2.96602 12.3766 2 14 2C16.2077 2 18 3.79228 18 6C18 7.6244 17.0373 9.01893 15.6485 9.64757C14.8721 7.12026 12.8775 5.12623 10.3498 4.35067ZM2 12C2 8.68629 4.68629 6 8 6C11.3137 6 14 8.68629 14 12C14 15.3137 11.3137 18 8 18C4.68629 18 2 15.3137 2 12Z" />
    </svg>
  `
};
export {
  C as Coins
};
